import { ChipIdSet } from '../passPrinting/chipId';
import { isNilOrEmpty } from '../../../../language/module';
import * as R from 'ramda';
import { GuestDetails } from '../../../guestDetails';
import { getPreferredMedia } from '../module';
import { getResource } from '../../../../language/resources/getResource';


/**
 * Returns true if the given input is a string containing a 20 digit number, otherwise returns false.
 */
export const isTwentyDigitNumber = (testCase: string) => new RegExp('^[0-9]{20}$').test(testCase);


/**
 * Returns the error message to show if the given RFID code is known to belong to another guest. If no such collision is
 * found, you'll get back an `undefined`
 */
export const hasDuplicateRfid = (
  resources: Record<string, any>,
  guestId: string,
  chipId: string,
  knownAssociatedChipIds: ChipIdSet,
): string | undefined => {
  const duplicate    = R.find(item => item.chipIds.includes(chipId), knownAssociatedChipIds);
  const hasDuplicate = !isNilOrEmpty(duplicate) && duplicate!.guestId !== guestId;

  if (!hasDuplicate) {
    return undefined;
  }

  return getResource(resources, 'RFID_DUPLICATE_ERROR', duplicate!.firstName, duplicate!.lastName, chipId);
};


/**
 * Returns an error for the Assoc RFID form state if one exists. Otherwise, returns undefined.
 */
export const findRfidAssocError = (
  resources: Record<string, any>,
  guestId: string,
  chipId: string,
  knownAssociatedChipIds: ChipIdSet,
): string | undefined => {
  if (!isTwentyDigitNumber(chipId)) {
    return getResource(resources, 'RFID_LENGTH_ERROR');
  }

  return hasDuplicateRfid(resources, guestId, chipId, knownAssociatedChipIds);
};


/**
 * If the given guest isn't undefined, and if they have a media object in their media array -- this will return whether
 * or not that media object has an associated RFID chip ID. This only checks the preferred media, so if you need
 * something more nuanced that e.g. takes into account all of a guest's media -- this isn't your function.
 */
export const hasAssociatedRfid = (
  guest: GuestDetails | undefined,
): boolean => !!R.path([ 'chipID' ], getPreferredMedia(guest));
